import { Option } from 'components/MultiSelect';
import SelectAllMultiSelect, {
  SelectAllMultiSelectProps,
} from './SelectAllMultiSelect';

export default SelectAllMultiSelect;
export type { SelectAllMultiSelectProps, Option };
